import type { CountryCode } from 'libphonenumber-js';
import parsePhoneNumberDefault, { AsYouType, getCountryCallingCode } from 'libphonenumber-js';

export interface SupportedCountryType {
  readonly aliases: string[];
  readonly flag: string;
  readonly iso: CountryCode;
  readonly name: string;
  readonly placeholder: string;
  readonly countryCallingCode?: string;
}

export const getCountriesForSelect = (countriesList: SupportedCountryType[]): SupportedCountryType[] => {
  return countriesList.map(country => ({ ...country, countryCallingCode: getCountryCallingCode(country.iso) }));
};

export const getCountryFromPhone = (value: string, defaultCountry: CountryCode): CountryCode => {
  const parsed = parsePhoneNumberDefault(value, defaultCountry);
  return parsed?.country ?? defaultCountry;
};

export const getMaskPhoneNum = (phoneNum?: string, countryCode?: string): string => {
  if (phoneNum === undefined) return '';
  if (countryCode === undefined) return phoneNum;

  const formattedIntlNumber = new AsYouType().input(phoneNum);
  const countryCodeRegexp = `\\+${countryCode}\\s?`;

  return formattedIntlNumber ? formattedIntlNumber.replace(new RegExp(countryCodeRegexp), '').slice(0, 15) : '';
};
